import { SubscriptionManager } from '../SubscriptionManager.js';
import {
  trackPricingOpened,
  trackPricingPlanClick,
  normalizePaywallSurface,
} from './funnelAnalytics.js';

/** Always default monthly. Annual is an opt-in text link only — never the default path. */
export function getPreferredBillingCycle() {
  return 'monthly';
}

function trackRecommendedCheckout({
  tier,
  billing,
  source,
  calculatorTier,
  surface,
  pricingView,
}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'recommended_checkout_click', {
    event_category: 'conversion',
    event_label: `${tier}_${billing}`,
    tier,
    billing_cycle: billing,
    source,
    calculator_tier: calculatorTier,
    surface,
    paywall_surface: normalizePaywallSurface(surface),
    pricing_view: pricingView,
    value: 1,
  });
}

export async function startRecommendedCheckout({
  tier = 'essential',
  billing = getPreferredBillingCycle(),
  source = 'unknown',
  calculatorTier = 'unknown',
  surface = 'high_intent_paywall',
  pricingView = 'direct_recommended',
  email = '',
  couponCode = null,
} = {}) {
  trackRecommendedCheckout({
    tier,
    billing,
    source,
    calculatorTier,
    surface,
    pricingView,
  });

  trackPricingOpened({
    source,
    calculatorTier,
    surface,
    pricingView,
  });

  trackPricingPlanClick({
    tier,
    billing,
    source,
    calculatorTier,
    view: pricingView,
    surface,
  });

  return SubscriptionManager.subscribe(tier, billing, email, couponCode, {
    source,
    calculator_tier: calculatorTier,
    surface,
    pricing_view: pricingView,
  });
}

export function alertCheckoutFailure(error) {
  console.error('Recommended checkout error:', error);
  if (typeof window !== 'undefined') {
    window.alert('Unable to start checkout. Please try again or contact support@supercalcpro.com.au');
  }
}

/**
 * PDF export paywall: go straight to Advanced monthly checkout.
 * Opening the full pricing modal here was the main pricing_opened → no-click leak.
 */
export function startPdfUnlockCheckout({
  calculatorTier = 'advanced',
  surface = 'pdf_export',
} = {}) {
  return startRecommendedCheckout({
    tier: 'essential',
    billing: getPreferredBillingCycle(),
    source: 'pdf_export',
    calculatorTier,
    surface,
  });
}

/**
 * Direct Advanced monthly checkout (PDF / cold high-intent only).
 * Exhausted / post-result surfaces should prefer soft pricing via openPricingModal.
 */
export function startAdvancedUnlockCheckout({
  source = 'advanced_gate',
  surface = 'free_runs_exhausted',
  calculatorTier = 'advanced',
  billing = getPreferredBillingCycle(),
} = {}) {
  return startRecommendedCheckout({
    tier: 'essential',
    billing,
    source,
    calculatorTier,
    surface,
  });
}
